import useApi from "@/composables/useApi";
import { debounce } from "lodash";

export default function useAdjustmentCoefficients() {
    const { fetchResource, updateResource } = useApi();

    const data = () => ({
        items: [],
        laspeyres: {},
        paasche: {},
        fisher: {},
        years: [],
    });

    const updateItemData = debounce((financialItemId, year, volume, price) => {
        updateResource('/v2/finance-and-productivity/adjustment-coefficients', {
            financial_item_id: financialItemId,
            year,
            volume,
            price,
        });
    }, 400);

    const methods = {
        async fetchData(type = 'material') {
            const queryString = new URLSearchParams({ type }).toString();
            const response = await fetchResource(
                '/v2/finance-and-productivity/adjustment-coefficients?' + queryString
            );

            this.items = response.items;
            this.laspeyres = response.indices.laspeyres;
            this.paasche = response.indices.paasche;
            this.fisher = response.indices.fisher;
            this.years = response.years;
        },

        handleItemDataChange(financialItemId, year, volume, price) {
            updateItemData(financialItemId, year, volume, price);
        },
    };

    return {
        data,
        methods,
    };
}